import { DefaultTheme, theme } from '@chakra-ui/core';
import React from 'react';

const customTheme: DefaultTheme = {
  ...theme,
  breakpoints: ['325px', '370px', '420px', '500px', '768px'],
  fonts: {
    body: 'AvenirNextLTPro, Helvetica Neue, Segoe UI, sans-serif',
    heading: 'AvenirNextLTPro, Helvetica Neue, Segoe UI, sans-serif',
    mono: 'Menlo, monospace',
  },
  fontWeights: {
    ...theme.fontWeights,
    normal: 400,
    medium: 600,
    bold: 700,
  },
  radii: {
    ...theme.radii,
    sm: '0.5rem',
    md: '0.8rem',
  },
  fontSizes: {
    ...theme.fontSizes,
    xs: '1rem',
    sm: '1.4rem',
    md: '1.6rem',
    lg: '1.8rem',
    xl: '2rem',
    '2xl': '2.4rem',
    '3xl': '3.8rem',
    '4xl': '5rem',
    '5xl': '6rem',
    '6xl': '7rem',
  },
  colors: {
    ...theme.colors,
    gray: {
      ...theme.colors.gray,
      50: '#F2F2F2',
      100: '#EFEFEF',
      200: '#DBDBDB',
      300: '#B8B7B8',
      400: '#9B999B',
      500: '#7C797C',
      600: '#353839',
    },
    green: {
      50: '#deffe5',
      100: '#aeffc1',
      200: '#7dfe9b',
      300: '#4afe75',
      400: '#48FE73',
      500: '#20FE54',
      600: '#01F43A',
      700: '#01B72B',
      800: '#004d0e',
      900: '#001b00',
    },
  },
  icons: {
    ...theme.icons,

    mail: {
      path: (
        <>
          <path
            d="M10.0039 7.03307L1.75387 0.158065C1.46099 -0.0839556 1.02787 -0.0440598 0.784493 0.246043C0.541119 0.538917 0.581015 0.972042 0.872471 1.21542L9.12245 8.09042C9.25168 8.19767 9.40708 8.24994 9.56248 8.24994C9.75912 8.24994 9.95435 8.16609 10.0918 8.00245C10.3352 7.70957 10.2953 7.27645 10.0039 7.03307Z"
            fill="currentColor"
          />
          <path
            d="M29.5625 0H3.43747C1.54275 0 0 1.54275 0 3.43754V18.5625C0 20.473 1.54275 22 3.43747 22H29.5624C31.4571 22 32.9999 20.4573 32.9999 18.5625V3.43754C32.9999 1.54275 31.4572 0 29.5625 0ZM31.625 18.5625C31.625 19.6996 30.6996 20.625 29.5625 20.625H3.43747C2.30033 20.625 1.37498 19.6996 1.37498 18.5625V3.43754C1.37498 2.30039 2.30033 1.37504 3.43747 1.37504H29.5624C30.6995 1.37504 31.6249 2.30039 31.6249 3.43754V18.5625H31.625Z"
            fill="currentColor"
          />
          <path
            d="M28.1289 1.04977C27.9158 0.736275 27.4882 0.6579 27.1733 0.871046L15.897 8.58614C15.0472 9.16641 13.95 9.16641 13.1016 8.58614L1.82523 0.870981C1.51037 0.655128 1.08273 0.73621 0.869582 1.04971C0.656436 1.36321 0.736229 1.79086 1.04973 2.00536L12.3261 9.72045C12.9861 10.1728 13.7437 10.3983 14.5 10.3983C15.2562 10.3983 16.0138 10.1728 16.6738 9.72045L27.9502 2.00536C28.2637 1.79086 28.3434 1.36327 28.1289 1.04977Z"
            fill="currentColor"
          />

          <path
            d="M10.2154 0.246165C9.97207 -0.0439377 9.53759 -0.0838335 9.24607 0.158187L0.996089 7.03319C0.704568 7.27657 0.664736 7.71105 0.90811 8.00257C1.04423 8.16621 1.23946 8.25006 1.43746 8.25006C1.59286 8.25006 1.74961 8.19779 1.87748 8.09054L10.1275 1.21554C10.419 0.972164 10.4588 0.537621 10.2154 0.246165Z"
            fill="currentColor"
          />
        </>
      ),

      viewBox: '0 0 33 22',
    },

    money: {
      path: (
        <>
          <path
            d="M1.982 3.539c-.719-.359-1.4-.7-1.4-1.3s.657-.877 1.267-.877 1.267.274 1.267.877a.292.292 0 00.585 0A1.56 1.56 0 002.142.795v-.5a.292.292 0 10-.585 0v.5A1.56 1.56 0 00-.002 2.239c0 .96.914 1.417 1.721 1.82.719.359 1.4.7 1.4 1.3s-.657.877-1.267.877S.585 5.962.585 5.359a.292.292 0 00-.585 0 1.56 1.56 0 001.559 1.444v.5a.292.292 0 00.585 0v-.5a1.56 1.56 0 001.559-1.444c0-.96-.915-1.417-1.721-1.82z"
            transform="translate(-30 -210) translate(37.236 212.723)"
          ></path>
          <g stroke="currentColor" fill="none" transform="translate(-30 -210) translate(30 210)">
            <rect stroke="none" width="18" height="13.5" rx="3"></rect>
            <rect fill="none" width="17" height="12.5" x="0.5" y="0.5" rx="2.5"></rect>
          </g>
        </>
      ),
      viewBox: '0 0 18 13.5',
    },

    'profile-email': {
      path: (
        <path
          fill="currentColor"
          d="M19,4H5A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3Zm-.67,2L12,10.75,5.67,6ZM19,18H5a1,1,0,0,1-1-1V7.25l7.4,5.55a1,1,0,0,0,1.2,0L20,7.25V17A1,1,0,0,1,19,18Z"
        />
      ),
      viewBox: '0 0 24 24',
    },

    'profile-photo': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M19,7H16V5.5A2.5,2.5,0,0,0,13.5,3h-3A2.5,2.5,0,0,0,8,5.5V7H5a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V10A3,3,0,0,0,19,7ZM10,5.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5V7H10ZM20,18a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V10A1,1,0,0,1,5,9H19a1,1,0,0,1,1,1Z"
          />
          <path
            fill="currentColor"
            d="M12,10.5A3.5,3.5,0,1,0,15.5,14,3.5,3.5,0,0,0,12,10.5Zm0,5A1.5,1.5,0,1,1,13.5,14,1.5,1.5,0,0,1,12,15.5Z"
          />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'profile-password': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M17,8H16V6.11a4,4,0,1,0-8,0V8H7a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V11A3,3,0,0,0,17,8ZM10,6.11a2,2,0,1,1,4,0V8H10ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z"
          />
          <path
            fill="currentColor"
            d="M12,12a3,3,0,1,0,3,3A3,3,0,0,0,12,12Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,12,16Z"
          />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'profile-infos': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M21.66,4.25a1,1,0,0,0-1.41.09L18.38,6.49l-.63-.71a1,1,0,0,0-1.5,1.33l1.39,1.56a1,1,0,0,0,1.49-.01l2.61-3a1,1,0,0,0-.08-1.41Z"
          />
          <path
            fill="currentColor"
            d="M10,11A4,4,0,1,0,6,7a4,4,0,0,0,4,4Zm0-6A2,2,0,1,1,8,7,2,2,0,0,1,10,5Z"
          />
          <path
            fill="currentColor"
            d="M10,13a7,7,0,0,0-7,7,1,1,0,0,0,2,0,5,5,0,1,1,10,0,1,1,0,0,0,2,0A7,7,0,0,0,10,13Z"
          />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'verify-address': {
      path: (
        <g transform="translate(-10.368 -10.382)">
          <path
            fill="currentColor"
            d="M31.722,40.2a8.427,8.427,0,1,1,8.427-8.427A8.437,8.437,0,0,1,31.722,40.2Zm0-16.026a7.6,7.6,0,1,0,7.6,7.6A7.607,7.607,0,0,0,31.722,24.173Z"
            transform="translate(-9.854 -9.883)"
          />
          <path
            fill="currentColor"
            d="M48.207,52.378a4.123,4.123,0,1,1,4.123-4.123A4.128,4.128,0,0,1,48.207,52.378Zm0-7.418a3.295,3.295,0,1,0,3.3,3.3A3.3,3.3,0,0,0,48.207,44.96Z"
            transform="translate(-26.339 -26.366)"
          />
          <path
            fill="currentColor"
            d="M62.413,14.29A.414.414,0,0,1,62,13.876V11.3a.414.414,0,1,1,.828,0v2.58A.414.414,0,0,1,62.413,14.29Z"
            transform="translate(-40.545)"
          />
          <path
            fill="currentColor"
            d="M62.413,104.146a.414.414,0,0,1-.414-.414v-2.566a.414.414,0,1,1,.828,0v2.566A.414.414,0,0,1,62.413,104.146Z"
            transform="translate(-40.545 -71.264)"
          />
          <path
            fill="currentColor"
            d="M13.855,62.876H11.282a.414.414,0,0,1,0-.828h2.573a.414.414,0,1,1,0,.828Z"
            transform="translate(0 -40.573)"
          />
          <path
            fill="currentColor"
            d="M103.69,62.876h-2.573a.414.414,0,0,1,0-.828h2.573a.414.414,0,1,1,0,.828Z"
            transform="translate(-71.236 -40.573)"
          />
        </g>
      ),
      viewBox: '0 0 23 23',
    },

    success: {
      path: (
        <g transform="translate(-168 -81)">
          <g transform="translate(171.752 84.752)">
            <path
              fill="currentColor"
              d="M48.248,2A46.248,46.248,0,1,0,94.5,48.248,46.248,46.248,0,0,0,48.248,2ZM68.134,37.195,47,64.943a4.639,4.639,0,0,1-7.307.046L28.408,50.607a4.63,4.63,0,1,1,7.307-5.688l7.538,9.62L60.735,31.414a4.653,4.653,0,1,1,7.4,5.642Z"
              transform="translate(-2 -2)"
            />
          </g>
        </g>
      ),
      viewBox: '0 0 100 100',
    },

    'menu-orders': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M21,6a3,3,0,0,0-3-3H6A3,3,0,0,0,4,8.22V18a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V8.22A3,3,0,0,0,21,6ZM6,5H18a1,1,0,0,1,0,2H6A1,1,0,0,1,6,5ZM18,18a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V9H18Z"
          />
          <rect fill="currentColor" width="6" height="2" rx="0.87" transform="translate(9 12)" />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'menu-fidelity': {
      path: (
        <g transform="translate(-302.5 -436.7)">
          <path
            fill="currentColor"
            d="M321.75,436.7h-16.5a2.7,2.7,0,0,0-2.75,2.75v11a2.7,2.7,0,0,0,2.75,2.75h16.5a2.7,2.7,0,0,0,2.75-2.75v-11A2.82,2.82,0,0,0,321.75,436.7Zm.917,13.75a.866.866,0,0,1-.917.917h-16.5a.866.866,0,0,1-.917-.917v-11a.866.866,0,0,1,.917-.917h16.5a.866.866,0,0,1,.917.917Z"
            transform="translate(0 0)"
          />
          <path
            fill="currentColor"
            d="M314.554,442.337l-.458.458-.458-.458a2.324,2.324,0,0,0-3.3,0,2.215,2.215,0,0,0,0,3.208l3.392,3.392a.337.337,0,0,0,.275.092c.092,0,.275,0,.275-.092l3.392-3.392a2.215,2.215,0,0,0,0-3.208A2.109,2.109,0,0,0,314.554,442.337Zm2.658,2.567-3.117,3.117-3.117-3.117a1.472,1.472,0,0,1-.458-1.008,1.374,1.374,0,0,1,1.467-1.375,1.923,1.923,0,0,1,1.008.367l.825.825a.443.443,0,0,0,.642,0l.825-.825a1.439,1.439,0,0,1,2.017,0h0A1.532,1.532,0,0,1,317.212,444.9Z"
            transform="translate(-0.596 -0.412)"
          />
        </g>
      ),
      viewBox: '0 0 22 16.5',
    },

    'menu-coupons': {
      path: (
        <g fill="currentColor" transform="translate(-1711.5 3955.3) rotate(90)">
          <path
            fill="currentColor"
            d="M-3955.3-1725.7v3.5a.683.683,0,0,0,.7.7,1.839,1.839,0,0,1,1.9,1.9,1.9,1.9,0,0,1-1.9,1.9.764.764,0,0,0-.5.2.763.763,0,0,0-.2.5v3.5a2.006,2.006,0,0,0,2,2h17.5a2.006,2.006,0,0,0,2-2v-3.5a.683.683,0,0,0-.7-.7,1.839,1.839,0,0,1-1.9-1.9,1.9,1.9,0,0,1,1.9-1.9.684.684,0,0,0,.7-.7v-3.5a2.006,2.006,0,0,0-2-2h-17.5A2.149,2.149,0,0,0-3955.3-1725.7Zm2-.6h17.5a.645.645,0,0,1,.6.6v2.8a3.228,3.228,0,0,0-2.6,3.2,3.31,3.31,0,0,0,2.6,3.2v2.8a.645.645,0,0,1-.6.6h-17.5a.645.645,0,0,1-.6-.6v-2.8a3.228,3.228,0,0,0,2.6-3.2,3.31,3.31,0,0,0-2.6-3.2v-2.8A.646.646,0,0,1-3953.3-1726.3Z"
          />
          <g fill="currentColor" transform="translate(-3950.59 -1714.468) rotate(-90)">
            <path
              fill="currentColor"
              d="M.4,0A.43.43,0,0,0,0,.4H0v1a.43.43,0,0,0,.4.4h0a.43.43,0,0,0,.4-.4h0V.4C.9.2.7,0,.4,0Z"
            />
            <path
              fill="currentColor"
              d="M.4,2.1h0a.684.684,0,0,1-.7-.7V.4A.684.684,0,0,1,.4-.3a.764.764,0,0,1,.5.2.764.764,0,0,1,.2.5v1a.764.764,0,0,1-.2.5A.764.764,0,0,1,.4,2.1Zm0-.5a.1.1,0,0,0,.1-.1l.1-.1V.4A.215.215,0,0,0,.4.2h0A.215.215,0,0,0,.2.4v1c.1.1.1.2.2.2Z"
            />
            <path
              fill="currentColor"
              d="M.4,3.6A.366.366,0,0,0,0,4H0v.9a.43.43,0,0,0,.4.4h0a.43.43,0,0,0,.4-.4h0V4c.1-.3-.1-.4-.4-.4Z"
            />
            <path
              fill="currentColor"
              d="M.4,5.5h0a.684.684,0,0,1-.7-.7V4a.764.764,0,0,1,.2-.5.764.764,0,0,1,.5-.2h0a.684.684,0,0,1,.7.7v.9a.764.764,0,0,1-.2.5A.749.749,0,0,1,.4,5.5ZM.4,5h0a.215.215,0,0,0,.2-.2V4a.215.215,0,0,0-.2-.2h0c-.1,0-.1.1-.2.2v.9c.1,0,.1.1.2.1Z"
            />
            <path
              fill="currentColor"
              d="M.4,7a.43.43,0,0,0-.4.4H0v.9a.43.43,0,0,0,.4.4h0a.43.43,0,0,0,.4-.4h0V7.4C.9,7.2.7,7,.4,7Z"
            />
            <path
              fill="currentColor"
              d="M.4,9h0a.842.842,0,0,1-.7-.7V7.4c.1-.1.1-.3.3-.4a.764.764,0,0,1,.5-.2A.764.764,0,0,1,1,7a.764.764,0,0,1,.2.5v.9a.764.764,0,0,1-.2.5C.8,8.9.6,9,.4,9Zm0-.5a.215.215,0,0,0,.2-.2V7.4a.1.1,0,0,0-.1-.1L.4,7.2h0a.215.215,0,0,0-.2.2v.9c.1.1.1.2.2.2Z"
            />
            <path
              fill="currentColor"
              d="M.4,10.5a.43.43,0,0,0-.4.4H0v.9a.43.43,0,0,0,.4.4h0a.43.43,0,0,0,.4-.4h0v-.9c.1-.3-.1-.4-.4-.4Z"
            />
            <path
              fill="currentColor"
              d="M.4,12.4h0a.684.684,0,0,1-.7-.7v-.9a.764.764,0,0,1,.2-.5.764.764,0,0,1,.5-.2h0a.764.764,0,0,1,.5.2.764.764,0,0,1,.2.5v.9a.764.764,0,0,1-.2.5C.8,12.4.6,12.4.4,12.4Zm0-.5h0a.215.215,0,0,0,.2-.2v-.9a.1.1,0,0,0-.1-.1l-.1-.1h0a.1.1,0,0,0-.1.1l-.1.1v.9c.1.1.1.2.2.2Z"
            />
            <path
              fill="currentColor"
              d="M9.4,1.9a.471.471,0,0,0-.6.1L3.6,9.8c-.1.2-.1.5.1.6h0c.2.1.5.1.6-.1L9.6,2.5a.481.481,0,0,0-.2-.6Z"
            />
            <path
              fill="currentColor"
              d="M3.9,10.7a.6.6,0,0,1-.4-.1.536.536,0,0,1-.3-.4c0-.1,0-.4.1-.5L8.5,1.9a.651.651,0,0,1,.9-.2h0c.5.2.6.6.4.9L4.5,10.4A.6.6,0,0,1,3.9,10.7ZM9.2,2.1c-.1,0-.1,0-.2.1L3.8,9.9V10a.1.1,0,0,0,.1.1c.1.1.2,0,.3,0L9.5,2.3a.139.139,0,0,0,0-.2H9.2Z"
            />
            <path
              fill="currentColor"
              d="M6.1,4A2.078,2.078,0,0,0,4.3,1.8,2.08,2.08,0,0,0,2.6,4,1.925,1.925,0,0,0,4.4,6.1,1.917,1.917,0,0,0,6.1,4ZM3.5,4c0-.7.4-1.3.9-1.3s.8.6.8,1.3-.4,1.3-.8,1.3S3.5,4.7,3.5,4Z"
            />
            <path
              fill="currentColor"
              d="M4.4,6.4A2.162,2.162,0,0,1,2.4,4a2.292,2.292,0,0,1,2-2.4A2.23,2.23,0,0,1,6.4,4,2.23,2.23,0,0,1,4.4,6.4ZM4.3,2.1A1.707,1.707,0,0,0,2.9,4,1.706,1.706,0,0,0,4.4,5.9,1.706,1.706,0,0,0,5.9,4h0A1.714,1.714,0,0,0,4.3,2.1Zm.1,3.4A1.443,1.443,0,0,1,3.2,4c0-.8.5-1.5,1.1-1.5A1.373,1.373,0,0,1,5.5,4C5.5,4.9,5,5.5,4.4,5.5Zm0-2.6c-.3,0-.6.4-.6,1s.3,1,.6,1S5,4.6,5,4,4.7,2.9,4.4,2.9Z"
            />
            <path
              fill="currentColor"
              d="M8.7,6.1A2.08,2.08,0,0,0,7,8.3a2.08,2.08,0,0,0,1.7,2.2,2.092,2.092,0,0,0,1.8-2.2A2.078,2.078,0,0,0,8.7,6.1Zm0,3.5c-.4,0-.8-.6-.8-1.3S8.3,7,8.7,7s.9.6.9,1.3S9.2,9.6,8.7,9.6Z"
            />
            <path
              fill="currentColor"
              d="M8.8,10.7a2.162,2.162,0,0,1-2-2.4A2.088,2.088,0,0,1,8.7,5.9h.1a2.23,2.23,0,0,1,2,2.4A2.23,2.23,0,0,1,8.8,10.7Zm0-4.3A1.765,1.765,0,0,0,7.3,8.3a1.706,1.706,0,0,0,1.5,1.9,1.765,1.765,0,0,0,1.5-1.9A1.85,1.85,0,0,0,8.8,6.4Zm0,3.4c-.6,0-1.1-.7-1.1-1.5,0-.9.5-1.5,1.1-1.5s1.1.7,1.1,1.5C9.9,9.2,9.4,9.8,8.8,9.8Zm0-2.5c-.3,0-.6.4-.6,1s.3,1,.6,1,.6-.4.6-1S9,7.3,8.8,7.3Z"
            />
          </g>
        </g>
      ),
      viewBox: '0 0 16.2 21.5',
    },

    'menu-pin': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M12,2A8,8,0,0,0,4,9.92c0,5.48,7.05,11.58,7.35,11.84a1,1,0,0,0,1.3,0C13,21.5,20,15.4,20,9.92A8,8,0,0,0,12,2Zm0,17.65c-1.67-1.59-6-6-6-9.73a6,6,0,1,1,12,0C18,13.62,13.67,18.06,12,19.65Z"
          />
          <path
            fill="currentColor"
            d="M12,6a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,12,6Zm0,5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,11Z"
          />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    exit: {
      path: (
        <g>
          <path
            fill="currentColor"
            d="M7,6A1,1,0,0,0,7,4H5A1,1,0,0,0,4,5V19a1,1,0,0,0,1,1H7a1,1,0,0,0,0-2H6V6Z"
          />
          <path
            fill="currentColor"
            d="M20.82,11.42,18,7.42a1,1,0,1,0-1.63,1.16L18.09,11H10a1,1,0,0,0,0,2h8l-1.8,2.4a1,1,0,0,0,1.6,1.2l3-4a1,1,0,0,0,.02-1.18Z"
          />
        </g>
      ),
      viewBox: '0 0 24 24',
    },

    'hidden-input-off': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M4.71,3.29A1,1,0,1,0,3.29,4.71l5.63,5.63a3.5,3.5,0,0,0,4.74,4.74l5.63,5.63a1,1,0,1,0,1.42-1.42ZM12,13.5A1.5,1.5,0,0,1,10.5,12v-.07l1.56,1.56Z"
          />
          <path
            fill="currentColor"
            d="M12.22,17c-4.3.1-7.12-3.59-8-5A13.7,13.7,0,0,1,6.46,9.28L5,7.87A15.89,15.89,0,0,0,2.13,11.5a1,1,0,0,0,0,1c.63,1.09,4,6.5,9.89,6.5h.25a9.48,9.48,0,0,0,3.23-.67l-1.58-1.58a7.74,7.74,0,0,1-1.7.25Z"
          />
          <path
            fill="currentColor"
            d="M21.87,11.5C21.23,10.39,17.7,4.82,11.73,5a9.48,9.48,0,0,0-3.23.67l1.58,1.58A7.74,7.74,0,0,1,11.78,7c4.29-.11,7.11,3.59,8,5a13.7,13.7,0,0,1-2.29,2.72L19,16.13a15.89,15.89,0,0,0,2.91-3.63,1,1,0,0,0-.04-1Z"
          />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'hidden-input-on': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M21.87,11.5c-.64-1.11-4.16-6.68-10.14-6.5C6.2,5.14,3,10,2.13,11.5a1,1,0,0,0,0,1c.63,1.09,4,6.5,9.89,6.5h.25c5.53-.14,8.74-5,9.6-6.5A1,1,0,0,0,21.87,11.5ZM12.22,17c-4.31.1-7.12-3.59-8-5,1-1.61,3.61-4.9,7.61-5,4.29-.11,7.11,3.59,8,5-1.03,1.61-3.61,4.9-7.61,5Z"
          />
          <path
            fill="currentColor"
            d="M12,8.5A3.5,3.5,0,1,0,15.5,12,3.5,3.5,0,0,0,12,8.5Zm0,5A1.5,1.5,0,1,1,13.5,12,1.5,1.5,0,0,1,12,13.5Z"
          />
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'google-icon': {
      path: (
        <g fill="currentColor" transform="translate(89 -90)">
          <g transform="translate(-89 90)">
            <path
              d="M19.825,8.132a.4.4,0,0,0-.389-.322H10.211a.4.4,0,0,0-.4.4v3.8a.4.4,0,0,0,.4.4h4.53a5.315,5.315,0,0,1-9.718-.537A5.314,5.314,0,0,1,12.809,5.49a.4.4,0,0,0,.46-.029l3.111-2.547a.4.4,0,0,0,0-.611,9.982,9.982,0,1,0,3.442,5.83ZM10,.792a9.223,9.223,0,0,1,5.5,1.821l-2.516,2.06A6.107,6.107,0,0,0,4.431,7.5L1.976,5.486A9.215,9.215,0,0,1,10,.792ZM.792,10a9.156,9.156,0,0,1,.817-3.792L4.141,8.281a6.13,6.13,0,0,0,.047,3.592l-2.516,2.06A9.237,9.237,0,0,1,.792,10ZM10,19.208a9.2,9.2,0,0,1-7.952-4.561l2.448-2A6.106,6.106,0,0,0,12.841,15.4l2.533,2.074A9.23,9.23,0,0,1,10,19.208Zm9.007-7.285a9.234,9.234,0,0,1-3,5.053l-2.458-2.012a6.127,6.127,0,0,0,2.165-2.82.4.4,0,0,0-.371-.535h-4.74V8.6h8.5a9.29,9.29,0,0,1-.1,3.321Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      ),
      viewBox: '0 0 20 20',
    },

    'apple-icon': {
      path: (
        <path
          fill="currentColor"
          className="a"
          d="M16.7,13.049a5.429,5.429,0,0,0,3.3,4.97,13.442,13.442,0,0,1-1.7,3.493c-1.024,1.5-2.086,2.987-3.76,3.018-1.645.03-2.174-.975-4.054-.975s-2.467.944-4.024,1.006c-1.616.061-2.846-1.618-3.878-3.109C.475,18.4-1.137,12.835,1.027,9.077A6.013,6.013,0,0,1,6.11,6c1.587-.03,3.084,1.067,4.054,1.067s2.789-1.32,4.7-1.126a5.738,5.738,0,0,1,4.492,2.436A5.555,5.555,0,0,0,16.7,13.049M13.612,3.922A5.41,5.41,0,0,0,14.89,0a5.506,5.506,0,0,0-3.618,1.862,5.141,5.141,0,0,0-1.3,3.8,4.555,4.555,0,0,0,3.644-1.739"
        />
      ),
      viewBox: '0 0 20 24.563',
    },

    'arrow-back': {
      path: (
        <g fill="currentColor" transform="rotate(180 15.096 15.736)">
          <path
            d="M0 0H31.471V30.193H0z"
            style={{ opacity: '0' }}
            transform="rotate(-90 15.736 15.736)"
          ></path>
          <path d="M12.366 23.072a1.4 1.4 0 01-.8-.241 1.011 1.011 0 01-.446-.712.943.943 0 01.286-.772l5.584-5.622-5.385-5.637a.939.939 0 01-.272-.772 1.018 1.018 0 01.459-.707 1.406 1.406 0 01.951-.257 1.316 1.316 0 01.874.414l6.021 6.3a.925.925 0 010 1.333l-6.233 6.3a1.362 1.362 0 01-1.039.373z"></path>
        </g>
      ),
      viewBox: '0 0 30.193 31.471',
    },

    flash: {
      path: (
        <path
          fill="currentColor"
          d="M6.926 4.984H4.2L6.553.53a.378.378 0 000-.354A.327.327 0 006.267 0H2.309A.332.332 0 002 .242L.017 6.643a.376.376 0 00.045.319.324.324 0 00.268.148h2.8L1.346 11.6a.368.368 0 00.126.438.313.313 0 00.423-.064l5.277-6.4a.375.375 0 00.054-.38.33.33 0 00-.3-.21zm0 0"
        ></path>
      ),
      viewBox: '0 0 7.256 12.094',
    },

    // Erro no typescript se n usar esse nome
    'plus-square': {
      path: (
        <g fill="currentColor" strokeWidth="1.5" transform="translate(-364 -866.5)">
          <path d="M0 0L0 17" transform="translate(372.5 866.5)"></path>
          <path d="M0 0L0 17" transform="rotate(90 -247 628)"></path>
        </g>
      ),
      viewBox: '0 0 17 17',
    },

    minus: {
      path: (
        <path
          d="M0 0L0 17"
          fill="currentColor"
          strokeWidth="1.5"
          transform="translate(-364 -874.25) rotate(90 -247 628)"
        ></path>
      ),
      viewBox: '0 0 17 1.5',
    },

    message: {
      path: (
        <>
          <path opacity="0" d="M0 0H24V24H0z"></path>
          <circle fill="currentColor" cx="1" cy="1" r="1" transform="translate(11 10)"></circle>
          <circle fill="currentColor" cx="1" cy="1" r="1" transform="translate(15 10)"></circle>
          <circle fill="currentColor" cx="1" cy="1" r="1" transform="translate(7 10)"></circle>
          <path
            fill="currentColor"
            d="M19 3H5a3 3 0 00-3 3v15a1 1 0 001.51.86L8 19.14a1 1 0 01.55-.14H19a3 3 0 003-3V6a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H8.55a3 3 0 00-1.55.43l-3 1.8V6a1 1 0 011-1h14a1 1 0 011 1z"
          ></path>
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'shopping-bag': {
      path: (
        <>
          <path d="M0 0H24V24H0z" fill="currentColor" opacity="0"></path>
          <path
            fill="currentColor"
            d="M20.12 6.71l-2.83-2.83A3 3 0 0015.17 3H8.83a3 3 0 00-2.12.88L3.88 6.71A3 3 0 003 8.83V18a3 3 0 003 3h12a3 3 0 003-3V8.83a3 3 0 00-.88-2.12zm-12-1.42A1.05 1.05 0 018.83 5h6.34a1.05 1.05 0 01.71.29L17.59 7H6.41zM18 19H6a1 1 0 01-1-1V9h14v9a1 1 0 01-1 1z"
          ></path>
          <path
            fill="currentColor"
            d="M15 11a1 1 0 00-1 1 2 2 0 01-4 0 1 1 0 00-2 0 4 4 0 008 0 1 1 0 00-1-1z"
          ></path>
        </>
      ),
      viewBox: '0 0 24 24',
    },

    'heart-card': {
      path: (
        <>
          <path
            d="M323.5 436.7h-18a2.946 2.946 0 00-3 3v12a2.946 2.946 0 003 3h18a2.946 2.946 0 003-3v-12a3.076 3.076 0 00-3-3zm1 15a.945.945 0 01-1 1h-18a.945.945 0 01-1-1v-12a.945.945 0 011-1h18a.945.945 0 011 1z"
            transform="translate(-302.5 -436.7)"
          ></path>
          <path
            d="M315 442.4l-.5.5-.5-.5a2.535 2.535 0 00-3.6 0 2.416 2.416 0 000 3.5l3.7 3.7a.367.367 0 00.3.1c.1 0 .3 0 .3-.1l3.7-3.7a2.416 2.416 0 000-3.5 2.3 2.3 0 00-3.4 0zm2.9 2.8l-3.4 3.4-3.4-3.4a1.606 1.606 0 01-.5-1.1 1.5 1.5 0 011.6-1.5 2.1 2.1 0 011.1.4l.9.9a.483.483 0 00.7 0l.9-.9a1.569 1.569 0 012.2 0 1.672 1.672 0 01-.1 2.2z"
            transform="translate(-302.5 -436.7)"
          ></path>
        </>
      ),
      viewBox: '0 0 24 18',
    },

    'done-circle': {
      path: (
        <g transform="translate(-100 -134)">
          <circle cx="15" cy="15" r="15" fill="#383539" transform="translate(100 134)"></circle>
          <g transform="translate(101 135)">
            <path d="M0 0H28V28H0z" opacity="0"></path>
            <path
              d="M14 2a12 12 0 1012 12A12 12 0 0014 2zm5.16 9.132l-5.484 7.2a1.2 1.2 0 01-1.9.012l-2.924-3.732a1.2 1.2 0 011.9-1.476l1.956 2.5 4.536-6A1.207 1.207 0 0119.16 11.1z"
              fill="currentColor"
            ></path>
          </g>
        </g>
      ),
      viewBox: '0 0 30 30',
    },

    kuppi: {
      path: (
        <path
          d="M12.868.01l.576.058a11.435 11.435 0 012.206.451 11.952 11.952 0 014.718 2.734 12.021 12.021 0 013.146 4.815 12.274 12.274 0 01.6 2.6 11.8 11.8 0 01.063 2.11 11.894 11.894 0 01-1.388 5 12.047 12.047 0 01-3.74 4.234 11.885 11.885 0 01-3.992 1.832 12.51 12.51 0 01-1.857.316 12.042 12.042 0 01-1.753.033 11.826 11.826 0 01-4.234-1.008 12.028 12.028 0 01-3.941-2.8A12.034 12.034 0 01.694 16.15a12.358 12.358 0 01-.612-2.617 11.365 11.365 0 01-.064-2.1 11.93 11.93 0 013.025-7.368A11.911 11.911 0 018.3.594a11.431 11.431 0 012.461-.532l.576-.058zm5.905 11.269h-1.107c-.105 0-.143.025-.14.137a6.863 6.863 0 01-.047 1.183 5.324 5.324 0 01-1.7 3.193 5.294 5.294 0 01-4.151 1.4 4.937 4.937 0 01-1.815-.494 5.361 5.361 0 01-3.025-3.937 6.335 6.335 0 01-.083-1.359c0-.087-.019-.121-.121-.121H4.325c-.1 0-.121.038-.121.121.01.249 0 .5.016.749a7.772 7.772 0 00.252 1.653 7.742 7.742 0 002.6 4.061 7.728 7.728 0 005.506 1.826 6.836 6.836 0 001.313-.185 7.832 7.832 0 005.481-4.568 7.9 7.9 0 00.653-3.553c0-.091-.042-.1-.121-.1h-1.129zm-9.277-1.265a1.718 1.718 0 001.239-.5 1.717 1.717 0 00.507-1.236 1.711 1.711 0 00-.5-1.236 1.712 1.712 0 00-1.234-.5 1.728 1.728 0 00-1.231.5 1.728 1.728 0 00-.508 1.229 1.732 1.732 0 001.727 1.742zm7.238-1.739a1.716 1.716 0 00-.5-1.232 1.717 1.717 0 00-1.231-.5 1.722 1.722 0 00-1.236.508 1.722 1.722 0 00-.5 1.239 1.734 1.734 0 00.512 1.225 1.733 1.733 0 001.229.5 1.736 1.736 0 001.728-1.739z"
          fill="currentColor"
        ></path>
      ),
      viewBox: '0 0 24.202 24.202',
    },

    'order-accepted': {
      path: (
        <>
          <path
            d="M7.92932 16C7.84199 16 7.75666 15.9653 7.69332 15.9027C7.61466 15.824 7.57999 15.7107 7.60199 15.602L8.07332 13.2453C8.08666 13.18 8.11732 13.1207 8.16466 13.0747L13.35 7.88934C13.7393 7.5 14.3747 7.5 14.764 7.88934L15.7067 8.832C16.0967 9.222 16.0967 9.856 15.7067 10.246L10.5213 15.4313C10.4753 15.478 10.416 15.5093 10.3507 15.5227L7.99399 15.994C7.97266 15.998 7.95066 16 7.92932 16ZM8.70799 13.474L8.35466 15.2413L10.122 14.888L15.236 9.774C15.366 9.644 15.366 9.43267 15.236 9.30267L14.2933 8.36C14.1633 8.23 13.952 8.23 13.822 8.36L8.70799 13.474ZM10.286 15.1953H10.2927H10.286Z"
            fill="currentColor"
          />
          <path
            d="M6.33333 14H1.66667C0.747333 14 0 13.2527 0 12.3333V3.66667C0 2.74733 0.747333 2 1.66667 2H3C3.184 2 3.33333 2.14933 3.33333 2.33333C3.33333 2.51733 3.184 2.66667 3 2.66667H1.66667C1.11533 2.66667 0.666667 3.11533 0.666667 3.66667V12.3333C0.666667 12.8847 1.11533 13.3333 1.66667 13.3333H6.33333C6.51733 13.3333 6.66667 13.4827 6.66667 13.6667C6.66667 13.8507 6.51733 14 6.33333 14Z"
            fill="currentColor"
          />
          <path
            d="M11 8C10.816 8 10.6667 7.85067 10.6667 7.66667V3.66667C10.6667 3.11533 10.218 2.66667 9.66667 2.66667H8.33333C8.14933 2.66667 8 2.51733 8 2.33333C8 2.14933 8.14933 2 8.33333 2H9.66667C10.586 2 11.3333 2.74733 11.3333 3.66667V7.66667C11.3333 7.85067 11.184 8 11 8Z"
            fill="currentColor"
          />
          <path
            d="M7.66669 4H3.66669C3.11535 4 2.66669 3.55133 2.66669 3V1.66667C2.66669 1.48267 2.81602 1.33333 3.00002 1.33333H4.03335C4.18802 0.573333 4.86202 0 5.66669 0C6.47135 0 7.14535 0.573333 7.30002 1.33333H8.33336C8.51736 1.33333 8.66669 1.48267 8.66669 1.66667V3C8.66669 3.55133 8.21802 4 7.66669 4ZM3.33335 2V3C3.33335 3.18333 3.48335 3.33333 3.66669 3.33333H7.66669C7.85002 3.33333 8.00002 3.18333 8.00002 3V2H7.00002C6.81602 2 6.66669 1.85067 6.66669 1.66667C6.66669 1.11533 6.21802 0.666667 5.66669 0.666667C5.11535 0.666667 4.66669 1.11533 4.66669 1.66667C4.66669 1.85067 4.51735 2 4.33335 2H3.33335Z"
            fill="currentColor"
          />
          <path
            d="M9 6H2.33333C2.14933 6 2 5.85066 2 5.66666C2 5.48266 2.14933 5.33333 2.33333 5.33333H9C9.184 5.33333 9.33333 5.48266 9.33333 5.66666C9.33333 5.85066 9.184 6 9 6Z"
            fill="currentColor"
          />
          <path
            d="M9 8.00001H2.33333C2.14933 8.00001 2 7.85067 2 7.66668C2 7.48268 2.14933 7.33334 2.33333 7.33334H9C9.184 7.33334 9.33333 7.48268 9.33333 7.66668C9.33333 7.85067 9.184 8.00001 9 8.00001Z"
            fill="currentColor"
          />
          <path
            d="M9 9.99999H2.33333C2.14933 9.99999 2 9.85066 2 9.66666C2 9.48266 2.14933 9.33333 2.33333 9.33333H9C9.184 9.33333 9.33333 9.48266 9.33333 9.66666C9.33333 9.85066 9.184 9.99999 9 9.99999Z"
            fill="currentColor"
          />
        </>
      ),
      viewBox: '0 0 16 16',
    },

    'order-in-progress': {
      path: (
        <>
          <path
            d="M-1.90735e-05 9.19244C-1.90735e-05 8.7922 0.325688 8.4665 0.725925 8.4665H1.69385C2.09409 8.4665 2.4198 8.7922 2.4198 9.19244C2.4198 9.5075 2.21677 9.77368 1.93583 9.87386V9.91839C1.93583 10.052 2.04448 10.1604 2.17782 10.1604H2.66178V8.67412C2.24557 8.56595 1.93583 8.1904 1.93583 7.74055C1.93583 7.25611 2.29469 6.85756 2.75978 6.78715C2.43335 5.90609 3.00902 4.40363 4.2378 2.9377L3.83418 2.53408C3.73594 2.58078 3.63019 2.60667 3.52347 2.60667C3.33739 2.60667 3.15155 2.53601 3.00999 2.39445C2.72711 2.11134 2.72711 1.65084 3.00999 1.36773L4.03672 0.340999C4.31984 0.0578802 4.78033 0.0583641 5.06345 0.340999C5.28607 0.563864 5.33059 0.895378 5.20283 1.16495L5.60645 1.56857C7.32573 0.127813 9.09679 -0.416162 9.8542 0.341483C9.94881 0.436097 9.94881 0.58903 9.8542 0.683644L3.76521 6.77263H12.0991C12.6329 6.77263 13.067 7.20674 13.067 7.74055C13.067 8.1904 12.7572 8.56595 12.341 8.67412V10.1604H12.825C12.9583 10.1604 13.067 10.052 13.067 9.91839V9.87386C12.786 9.77368 12.583 9.5075 12.583 9.19244C12.583 8.7922 12.9087 8.4665 13.309 8.4665H14.2769C14.6771 8.4665 15.0028 8.7922 15.0028 9.19244C15.0028 9.5075 14.7998 9.77368 14.5189 9.87386V10.1604C14.5189 10.9611 13.8677 11.6123 13.067 11.6123H12.341V13.3061C12.341 14.2399 11.5812 15 10.6472 15H4.35565C3.4216 15 2.66178 14.2399 2.66178 13.3061V11.6123H1.93583C1.13512 11.6123 0.483944 10.9611 0.483944 10.1604V9.87386C0.203004 9.77368 -1.90735e-05 9.5075 -1.90735e-05 9.19244ZM4.72104 0.683644C4.62691 0.589272 4.47325 0.58903 4.37864 0.683644L3.35215 1.71037C3.25778 1.80475 3.25778 1.95816 3.35215 2.05253C3.44677 2.14715 3.60042 2.14691 3.69456 2.05253L4.72104 1.02581C4.81541 0.931434 4.81541 0.778017 4.72104 0.683644ZM4.89212 1.53929L4.20756 2.22386L4.55746 2.57352C4.66514 2.45616 4.77645 2.33952 4.89212 2.22386C5.00779 2.10819 5.12467 1.99688 5.24179 1.8892L4.89212 1.53929ZM5.23428 2.56578C3.8983 3.90176 2.836 5.79115 3.2135 6.63978L9.30853 0.544989C8.45941 0.16774 6.57026 1.2298 5.23428 2.56578ZM12.583 7.74055C12.583 7.47365 12.366 7.25659 12.0991 7.25659H2.90376C2.63685 7.25659 2.4198 7.47365 2.4198 7.74055C2.4198 8.00746 2.63685 8.22452 2.90376 8.22452H12.0991C12.366 8.22452 12.583 8.00746 12.583 7.74055ZM14.2769 8.95046H13.309C13.1756 8.95046 13.067 9.05887 13.067 9.19244C13.067 9.32602 13.1756 9.43442 13.309 9.43442H14.2769C14.4102 9.43442 14.5189 9.32602 14.5189 9.19244C14.5189 9.05887 14.4102 8.95046 14.2769 8.95046ZM13.067 11.1283C13.6008 11.1283 14.0349 10.6942 14.0349 10.1604V9.91839H13.5509C13.5509 10.3186 13.2252 10.6443 12.825 10.6443H12.341V11.1283H13.067ZM4.35565 14.516H10.6472C11.3143 14.516 11.8571 13.9733 11.8571 13.3061V8.70848H3.14574V13.3061C3.14574 13.9733 3.68851 14.516 4.35565 14.516ZM1.93583 11.1283H2.66178V10.6443H2.17782C1.77758 10.6443 1.45187 10.3186 1.45187 9.91839H0.967907V10.1604C0.967907 10.6942 1.40202 11.1283 1.93583 11.1283ZM0.725925 9.43442H1.69385C1.82718 9.43442 1.93583 9.32602 1.93583 9.19244C1.93583 9.05887 1.82718 8.95046 1.69385 8.95046H0.725925C0.592594 8.95046 0.483944 9.05887 0.483944 9.19244C0.483944 9.32602 0.592594 9.43442 0.725925 9.43442Z"
            fill="currentColor"
          />
          <path
            d="M2.87178 13.3055C2.87178 13.5724 3.0888 13.7894 3.35565 13.7894V14.2732C2.82194 14.2732 2.38791 13.8392 2.38791 13.3055V9.91841H2.87178V13.3055Z"
            fill="currentColor"
          />
          <path
            d="M10.0751 4.75069C9.95508 4.87069 9.88928 5.02989 9.88928 5.19924C9.88928 5.3686 9.95508 5.52779 10.0751 5.64779L10.5442 6.1169L10.2021 6.459L9.73299 5.98989C9.52153 5.77868 9.4054 5.49779 9.4054 5.19924C9.4054 4.90069 9.52153 4.61981 9.73299 4.4086L9.94565 4.19593C10.0654 4.07618 10.1312 3.91698 10.1312 3.74763C10.1312 3.57827 10.0654 3.41908 9.9454 3.29908L9.47629 2.82997L9.81839 2.48787L10.2875 2.95698C10.499 3.16819 10.6151 3.44908 10.6151 3.74763C10.6151 4.04618 10.499 4.32706 10.2875 4.53827L10.0751 4.75069Z"
            fill="currentColor"
          />
          <path
            d="M7.29847 2.82997L7.64056 2.48787L8.10968 2.95698C8.32113 3.16819 8.43726 3.44908 8.43726 3.74763C8.43726 4.04618 8.32113 4.32706 8.10968 4.53827L7.89701 4.75093C7.77726 4.87069 7.71145 5.02989 7.71145 5.19924C7.71145 5.3686 7.77726 5.52779 7.89726 5.64779L8.36637 6.1169L8.02427 6.459L7.55516 5.98989C7.34371 5.77868 7.22758 5.49779 7.22758 5.19924C7.22758 4.90069 7.34371 4.61981 7.55516 4.4086L7.76782 4.19593C7.88758 4.07618 7.95338 3.91698 7.95338 3.74763C7.95338 3.57827 7.88758 3.41908 7.76758 3.29908L7.29847 2.82997Z"
            fill="currentColor"
          />
        </>
      ),
      viewBox: '0 0 16 15',
    },

    'order-delivery': {
      path: (
        <>
          <path
            d="M1.11452 6.4794H4.6757C5.29024 6.4794 5.79022 6.97963 5.79022 7.59454V11.6934H7.12224C7.04821 11.4243 7.02077 11.1069 7.03878 10.7375V10.7374C7.06769 9.17643 7.35095 7.86081 7.88074 6.82713C8.29213 6.02458 8.77222 5.54343 9.18418 5.25578C8.70065 4.75863 8.42108 4.0514 8.42108 3.23572C8.42108 1.76814 9.59179 0.574219 11.0307 0.574219C12.4697 0.574219 13.6404 1.76814 13.6404 3.23572C13.6404 3.40565 13.5027 3.54334 13.3328 3.54334H13.1238C13.143 3.65941 13.1533 3.7777 13.1533 3.89784C13.1533 4.93209 12.4142 5.79649 11.4372 5.99021C11.5396 6.37051 11.5905 6.81893 11.5903 7.32834L12.3575 7.98824L14.2243 8.13922L16.3778 7.42736C16.5752 7.36173 16.7989 7.28757 16.9929 7.42752C17.1842 7.56554 17.1842 7.80716 17.1842 7.88653V9.48757C17.1842 9.6575 17.0465 9.79519 16.8766 9.79519H16.5103L17.0721 11.7362C17.1193 11.8994 17.0253 12.07 16.8621 12.1172C16.6988 12.1647 16.5283 12.0704 16.481 11.9072L15.8698 9.79519H14.9953C16.083 13.1122 15.4624 15.3263 14.5084 17.567H15.0613L17.3645 14.9918L16.8775 13.3094C16.8302 13.1462 16.9242 12.9756 17.0874 12.9284C17.2506 12.8812 17.4212 12.9752 17.4685 13.1383L17.9343 14.7477C19.375 14.7236 20.6637 15.7169 20.9921 17.146C21.0301 17.3116 20.9268 17.4766 20.7613 17.5147L20.3246 17.6152C20.4362 18.774 19.6731 19.8672 18.5093 20.1351C18.3326 20.1758 18.1543 20.1959 17.9773 20.1959C17.5407 20.1959 17.1118 20.0735 16.7325 19.8358C16.2873 19.5568 15.9555 19.1466 15.776 18.6619L15.4314 18.7412C15.3288 18.7649 15.2314 18.777 15.1341 18.7246C15.0436 18.6758 14.9834 18.5879 14.9609 18.4886C14.9392 18.3879 14.9227 18.2855 14.9113 18.1823H8.47764C8.27191 19.4614 7.18356 20.4257 5.88373 20.4257C4.58391 20.4257 3.49552 19.4614 3.28979 18.1823H3.05501C3.05501 18.1823 3.00842 18.1828 2.99779 18.1828C2.90981 18.1828 2.78275 18.173 2.67841 18.0669C2.62619 18.0138 2.56491 17.9187 2.56963 17.7678C2.57829 17.4789 2.62164 17.1998 2.69563 16.9345C2.4506 15.4469 2.68636 14.5409 3.03586 13.8319C2.81491 13.6871 2.6684 13.4375 2.6684 13.154V12.3086H1.1146C0.500065 12.3086 8.58307e-05 11.8084 8.58307e-05 11.1935V7.59449C3.8147e-06 6.97963 0.499943 6.4794 1.11452 6.4794ZM17.0592 19.3145C17.453 19.5613 17.9189 19.6398 18.3712 19.5357H18.3713C19.2038 19.344 19.7592 18.5806 19.7188 17.7551L16.382 18.5231C16.5201 18.8482 16.7537 19.1231 17.0592 19.3145ZM15.5199 18.0896L20.305 16.9885C19.9358 15.9773 18.942 15.3079 17.8558 15.3655L15.5117 17.9864C15.5138 18.021 15.5165 18.0554 15.5199 18.0896ZM10.8735 12.729C10.9628 12.9645 10.9628 13.2549 10.9628 13.6568V14.8176H12.0892V13.2251C12.0892 11.4246 11.1065 11.1037 10.6655 11.0508H7.6497C7.66184 11.4594 7.75405 11.7499 7.9291 11.9342C8.13311 12.1491 8.4822 12.2537 8.99637 12.2542L10.1006 12.2554C10.4943 12.2554 10.7543 12.4147 10.8735 12.729ZM10.9628 15.4328V16.1673C10.9656 16.1673 10.9684 16.1673 10.9714 16.1673H13.1564C13.1319 15.9395 13.0609 15.7632 12.9444 15.6413C12.771 15.4599 12.5269 15.4328 12.3968 15.4328H10.9628ZM7.66328 10.4356H10.4608C10.5732 10.0821 10.6733 9.69495 10.7557 9.29709L9.90515 8.74502C9.44086 8.44352 9.19931 8.01749 9.24246 7.57612C9.28069 7.18487 9.54668 6.83538 9.92008 6.68579C10.2611 6.54921 10.6281 6.59211 10.9525 6.79953C10.9258 6.50528 10.876 6.24262 10.804 6.01966C10.6728 6.00612 10.5426 5.98049 10.4147 5.94288C10.1544 5.88242 9.91385 5.78607 9.69667 5.65831C9.1042 6.01228 7.80113 7.16039 7.66328 10.4356ZM13.0027 2.92815C12.8576 1.94525 12.0286 1.18949 11.0307 1.18949C9.93103 1.18949 9.03632 2.10746 9.03632 3.23576C9.03632 4.15345 9.47637 4.89308 10.1859 5.21858V3.59998C10.1859 3.31972 10.2932 2.97593 10.804 2.92942C10.8133 2.92856 10.8226 2.92815 10.8319 2.92815H13.0027ZM12.538 3.89788C12.538 3.77647 12.5242 3.6579 12.497 3.54338H10.847C10.828 3.54543 10.8141 3.54765 10.8042 3.54966C10.8026 3.56106 10.8012 3.57747 10.8012 3.59998V5.39958C10.8745 5.41037 10.9483 5.41583 11.022 5.41587C11.0227 5.41587 11.0234 5.41587 11.024 5.41587C11.8589 5.41509 12.538 4.73443 12.538 3.89788ZM12.9368 8.65241L12.2082 8.59347C12.1433 8.58826 12.0817 8.56254 12.0323 8.52009L10.7173 7.38909L10.7171 7.38888C10.5899 7.27933 10.4542 7.22314 10.3221 7.22314C10.2633 7.22314 10.2051 7.23429 10.1488 7.25685C9.98628 7.32195 9.87086 7.47075 9.8547 7.63588C9.8344 7.84371 9.97131 8.05436 10.2401 8.22892L11.7054 9.17999H12.9367V8.65241H12.9368ZM14.2368 8.75757L13.552 8.7022V9.18008H14.3478C14.4509 9.18008 14.4761 9.09435 14.479 9.02245C14.4807 8.98168 14.4768 8.77726 14.2368 8.75757ZM14.9649 8.5452C15.0575 8.69712 15.1008 8.87484 15.0937 9.04764C15.0919 9.09238 15.0862 9.13549 15.0782 9.17749C15.0782 9.17835 15.0787 9.17921 15.0785 9.18003H16.5689V8.0122L14.9637 8.54282C14.9642 8.54364 14.9644 8.54442 14.9649 8.5452ZM14.346 9.79527H11.6144C11.5549 9.79527 11.4967 9.77804 11.4469 9.74568L11.3076 9.65528C11.2407 9.95133 11.1644 10.2394 11.0813 10.5115C11.7086 10.6967 12.7045 11.2952 12.7045 13.225V14.8485C12.9203 14.892 13.1756 14.9927 13.3892 15.2162C13.6143 15.4518 13.7429 15.771 13.7737 16.1673H14.3943C15.0196 14.3651 15.2574 12.4474 14.346 9.79527ZM13.839 17.566C13.9527 17.3045 14.0623 17.044 14.1655 16.7826H10.9714C10.5575 16.7826 10.3476 16.5941 10.3476 16.2225V15.1252V13.9644H7.9195C7.74958 13.9644 7.61189 13.8267 7.61189 13.6568C7.61189 13.4868 7.74958 13.3492 7.9195 13.3492H10.3454C10.3414 13.1744 10.3302 13.0315 10.2982 12.9471C10.2827 12.9061 10.2692 12.8706 10.1003 12.8706L8.99579 12.8695C8.30407 12.8688 7.80921 12.7015 7.48293 12.3578C7.46784 12.3419 7.45357 12.3252 7.43925 12.3086H5.48256H3.28351V13.1541C3.28351 13.2598 3.37263 13.3492 3.47813 13.3492H6.54056C6.71049 13.3492 6.84818 13.4868 6.84818 13.6568C6.84818 13.8267 6.71049 13.9644 6.54056 13.9644H3.65888C3.41574 14.4157 3.19705 14.9772 3.21005 15.8644C3.81864 15.0191 4.80388 14.4755 5.92204 14.4755C6.82004 14.4755 7.66266 14.8277 8.29476 15.4674C8.85565 16.0349 9.19251 16.7715 9.26182 17.567L13.839 17.566ZM5.88369 19.8105C6.84535 19.8105 7.65639 19.1176 7.85261 18.1824H3.91478C4.11104 19.1175 4.92208 19.8105 5.88369 19.8105ZM3.56533 17.5671H8.20198H8.64392C8.4929 16.1762 7.32986 15.0907 5.92204 15.0907C4.68604 15.0907 3.64806 15.9057 3.3043 17.0467C3.3032 17.0503 3.30209 17.0539 3.30086 17.0575C3.25225 17.2211 3.21792 17.3915 3.19934 17.5671H3.56533ZM0.615238 11.1935C0.615238 11.4692 0.839224 11.6934 1.11452 11.6934H5.17498V10.1048H0.615238V11.1935ZM0.615238 9.48958H5.17498V8.83534H0.615238V9.48958ZM0.615238 8.22011H5.17498V7.59454C5.17498 7.31887 4.951 7.09464 4.6757 7.09464H1.11452C0.839224 7.09464 0.615238 7.31891 0.615238 7.59454V8.22011Z"
            fill="currentColor"
          />
        </>
      ),
      viewBox: '0 0 21 21',
    },

    voucher: {
      path: (
        <>
          <g fill="currentColor" clipPath="url(#clip0)">
            <path d="M21.569 7.965A.422.422 0 0022 7.553V4.76a.422.422 0 00-.431-.412H.431A.422.422 0 000 4.76v2.793c0 .228.193.412.432.412 1.473 0 2.671 1.144 2.671 2.55s-1.198 2.55-2.671 2.55a.422.422 0 00-.432.412v2.794c0 .227.193.412.432.412h3.836a.422.422 0 00.432-.412.422.422 0 00-.432-.412H.863v-1.995c1.746-.204 3.103-1.628 3.103-3.349 0-1.72-1.357-3.145-3.103-3.349V5.171h14.821v.824c0 .228.194.412.432.412a.422.422 0 00.431-.412v-.824h4.59v1.995c-1.746.204-3.103 1.628-3.103 3.35 0 1.72 1.357 3.144 3.103 3.348v1.995h-4.59v-.824a.422.422 0 00-.431-.412.422.422 0 00-.432.412v.824H7.812a.422.422 0 00-.432.412c0 .227.193.412.432.412h13.756A.422.422 0 0022 16.27v-2.794a.422.422 0 00-.431-.412c-1.474 0-2.672-1.144-2.672-2.55s1.198-2.55 2.672-2.55z"></path>
            <path d="M16.116 12.434a.422.422 0 00.431-.412V9.009a.422.422 0 00-.431-.412.422.422 0 00-.432.412v3.013c0 .227.194.412.432.412zM9.19 9.931a1.57 1.57 0 00.495-1.143 1.57 1.57 0 00-.496-1.144 1.754 1.754 0 00-2.395 0 1.57 1.57 0 00-.497 1.144c0 .432.177.838.497 1.143.33.316.764.473 1.198.473a1.73 1.73 0 001.197-.473zM7.16 8.788a.77.77 0 01.244-.561.85.85 0 01.588-.232c.212 0 .425.077.587.232a.77.77 0 010 1.122.86.86 0 01-1.175 0 .77.77 0 01-.244-.561zM10.666 11.297c-.66.63-.66 1.656 0 2.287.33.315.764.473 1.198.473a1.73 1.73 0 001.198-.473c.66-.63.66-1.657 0-2.287a1.754 1.754 0 00-2.396 0zm1.786.582a.769.769 0 010 1.122.86.86 0 01-1.175 0 .769.769 0 010-1.122.849.849 0 01.587-.232.85.85 0 01.588.232zM7.98 13.067l4.495-4.29a.399.399 0 000-.583.446.446 0 00-.61 0l-4.495 4.29a.402.402 0 00-.026.556.45.45 0 00.636.027zM6.032 15.855c-.18 0-.344.11-.405.272a.403.403 0 00.13.457c.14.11.34.124.495.037a.408.408 0 00.204-.432.431.431 0 00-.424-.334z"></path>
          </g>
          <defs>
            <clipPath id="clip0">
              <path fill="#fff" d="M0 0H22V21H0z"></path>
            </clipPath>
          </defs>
        </>
      ),
      viewBox: '0 0 22 21',
    },
    clock: {
      path: (
        <>
          <g fill="currentColor">
            <path d="M11.65 5.648a.352.352 0 00-.352.352A5.303 5.303 0 016 11.297 5.303 5.303 0 01.704 6 5.303 5.303 0 016.001.703c.89 0 1.757.221 2.53.643l-.44.44a.352.352 0 00.25.6h1.682a.352.352 0 00.351-.352V.352a.351.351 0 00-.6-.249L9.047.83A5.977 5.977 0 006 0a5.96 5.96 0 00-4.243 1.757A5.96 5.96 0 00.001 6a5.96 5.96 0 001.757 4.243A5.961 5.961 0 006.001 12c1.603 0 3.11-.624 4.243-1.757A5.96 5.96 0 0012 6a.352.352 0 00-.352-.352z"></path>
            <path d="M8.26 5.648H6.351V3.741a.352.352 0 00-.704 0V6c0 .194.158.352.352.352h2.26a.352.352 0 000-.704z"></path>
          </g>
        </>
      ),
      viewBox: '0 0 12 12',
    },
    'scheduling-clock': {
      path: (
        <>
          <path
            fill="currentColor"
            d="M16.734 4.847L18.17 3.41l-1.3-1.3L15.3 3.68A6.39 6.39 0 0012 2.76a6.446 6.446 0 00-6.438 6.438c0 3.55 2.889 6.439 6.438 6.439a6.446 6.446 0 006.439-6.439c0-1.613-.61-3.167-1.706-4.35zM12 13.797a4.604 4.604 0 01-4.599-4.599 4.604 4.604 0 014.6-4.599A4.604 4.604 0 0116.6 9.198a4.604 4.604 0 01-4.599 4.599z"
          ></path>
          <path
            fill="currentColor"
            d="M11.082 6.439h1.84v3.679h-1.84v-3.68zM10.162 0h3.679v1.84h-3.68V0zM.964 4.599h3.679v1.84H.963v-1.84zm0 7.358h3.679v1.84H.963v-1.84zm-.92-3.679h3.67v1.84H.044v-1.84z"
          ></path>
        </>
      ),
      viewBox: '0 0 19 16',
    },
    'ios-share': {
      path: (
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5.5 8.1H3.125c-.564 0-1.104.232-1.503.646A2.25 2.25 0 001 10.306v10.588c0 .585.224 1.146.622 1.56.399.414.94.646 1.503.646h12.75c.564 0 1.104-.232 1.503-.646a2.25 2.25 0 00.622-1.56V10.306a2.25 2.25 0 00-.622-1.56 2.086 2.086 0 00-1.503-.646H13M13.431 4.453L9.5 1 5.834 4.453M9.5 15.503V1"
        ></path>
      ),
      viewBox: '0 0 19 25',
    },
  },
};

export default customTheme;
